import { jsx as i } from "react/jsx-runtime";
import d from "../../utils/classNames.js";
import { useDialogContext as m } from "./dialogContext.js";
const f = (o) => {
  const { className: s = "", children: r, ...a } = o, { isSmallestDialog: e, showXsDialogBorders: t } = m(), l = d(
    "modal-footer",
    !(e ? t : !0) && "border-top-none padding-top-0",
    s
  );
  return /* @__PURE__ */ i("div", { ...a, className: l, "aria-label": "dialog footer", children: r });
};
export {
  f as default
};
//# sourceMappingURL=DialogFooter.js.map
